import { systemRequirementsUrl } from '../../constants'
import { idsUserManualUrl } from '../../constants'
import { idsCalFilesInstructionsUrl } from '../../constants'
import { idsMissingCalFilesInstructionsUrl } from '../../constants'
import { idsMissingCalFilesInstructionsUrlMp4 } from '../../constants'
import { softwareExplainedUrl } from '../../constants'
import { isVersionUnavailable } from '../../lib/helpers'

import moment from 'moment'

const IDSSoftwareValidSubscription = ({ t, i18n, softwareLinksMap }) => (
  <div className="content" id="idsSoftware">
    <h4 className="is-size-4 m-b-md">{t('common:ids-page-subtitle')}</h4>
    <p><a href={softwareExplainedUrl(i18n.language)} target="_blank">{t('common:subscription-common')}</a></p>
    <div className="m-b-md">
          {t('common:ids-page-content-17', {
            version: softwareLinksMap['IDS'].name,
            date: moment(softwareLinksMap['IDS'].release_date).format('MM/DD/YYYY')
          })}
      <a href="/api/download/private/IDS">{t('common:click-download')}</a>
      <br />          
            {t('common:ids-page-content-9', {
              version: softwareLinksMap['IDS_UPDATE'].name
            })}
      {!isVersionUnavailable(softwareLinksMap['IDS_UPDATE'].name) && (
        <span>
          {' - '}
          <a href="/api/download/private/IDS_UPDATE">{t('common:click-download')}</a>
        </span>
      )}
      <br />
      <strong>{t('common:ids-page-content-33')}</strong>
      <br />
      <strong> {t('common:ids-page-content-22')} {t('common:ids-page-content-31')}</strong>
    </div>
    <div className="m-b-md">      
      <a href={idsCalFilesInstructionsUrl(i18n.language)}
        target="_blank">
        {t('common:ids-page-content-23')}
          </a>
      <ul>
        <li><a href="https://s3.us-east-1.amazonaws.com/tsd.mazdausa.com/IDS/Cal%20Files/Cal_Installer_1_1_CX3_9_MX5_TCM_Service_C.exe"
          target="_blank">
          {t('common:ids-page-content-24')}
        </a></li>        
        <li><a href="https://s3.us-east-1.amazonaws.com/tsd.mazdausa.com/IDS/Cal%20Files/Cal_Installer_1_1_CX5_C %281%29.exe"
          target="_blank">
          {t('common:ids-page-content-25')}
        </a></li>
        <li><a href="https://s3.us-east-1.amazonaws.com/tsd.mazdausa.com/IDS/Cal%20Files/Cal_Installer_1_1_Mazda2_3_6_C.exe"
          target="_blank">
          {t('common:ids-page-content-26')}
        </a></li>                
        <li><a href="https://s3.us-east-1.amazonaws.com/tsd.mazdausa.com/IDS/Cal%20Files/Cal_Installer_1_1_OtherVehicles_C.exe"
          target="_blank">
          {t('common:ids-page-content-27')}
        </a></li>        
      </ul>
      <p>        
        <a href={idsMissingCalFilesInstructionsUrl(i18n.language)}
          target="_blank">
          {t('common:ids-page-content-28')}
        </a>
      </p>
      <p>        
        <a href={idsMissingCalFilesInstructionsUrlMp4(i18n.language)}
          target="_blank">
          {t('common:ids-page-content-32')}
        </a>
      </p>
      <ul>
        <li>{t('common:ids-page-content-29')}</li>
      </ul>
    </div>    
    <div>
          {t('common:ids-page-content-20')}&nbsp;
          <a href={idsUserManualUrl(i18n.language)}
            target="_blank">
            {t('common:here')}
          </a>
      <br />
      {t('common:ids-page-content-8')}&nbsp;
      <a href={systemRequirementsUrl(i18n.language)}
        target="_blank">
        {t('common:click-here')}
      </a>
    </div>
  </div>
)

export default IDSSoftwareValidSubscription



// WEBPACK FOOTER //
// ./components/IDSSoftware/WithValidSubscription.js